const ITEMS = [
  "SmartLock\u2122 · Nearly $3 Million SmartLocked",
  "EazyBot · Over 24 Million Profitable Trades",
  "SHYFT App · Keep More of Your Money",
  "SHYFT ORB · Passive Income Cheat Code",
];

export const Marquee = () => {
  return (
    <div
      data-testid="brand-marquee"
      className="relative border-y border-[rgba(201,162,91,0.18)] py-5 overflow-hidden bg-[#0a0a0a]"
    >
      <div className="marquee-track flex gap-12 whitespace-nowrap will-change-transform w-max">
        {Array.from({ length: 2 }).map((_, k) => (
          <div key={k} className="flex gap-12">
            {ITEMS.map((w) => (
              <span
                key={`${k}-${w}`}
                className="eyebrow !text-[#cfc8b9] flex items-center gap-12"
              >
                {w}
                <span className="w-1.5 h-1.5 rounded-full bg-[#1e90ff]/70 shadow-[0_0_8px_rgba(30,144,255,0.55)]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
